import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AlchemistAbandoned2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ALCHEMIST_ABANDONED2;
}

export default AlchemistAbandoned2PoiTileEntity;
